import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "../../../helpers/classNames";
import { imagePlaceholder, titlePlaceholder, } from "../../../helpers/placeholders";
import RenderElement from "../../../helpers/RenderElement";
import { SideEditOptions } from "../../../types/elements";
import Container from "../Common/Container";
import Typography from "../Common/Typography";
const HeroHeaderBackground = ({ elementId, elementProps }) => {
    const renderElement = RenderElement.setProps(elementProps);
    const containerBgRender = renderElement.renderBackgroundImage("container-1", "backgroundImage");
    const imageLocation = renderElement.renderProp("container-1", "img-location")?.value;
    return (_jsx("div", { "editor-elementid": elementId, "editor-key": "container-1", ...containerBgRender, ...renderElement.renderAttributeOptions([
            {
                type: SideEditOptions.BackgroundImage,
                config: { key: "backgroundimage" },
            },
            {
                type: SideEditOptions.BackgroundColor,
                config: {
                    key: "bg-cover",
                    valueKey: "backgroundColor",
                    defaultValue: "bg-site-400",
                    label: "Afbeelding overlay kleur",
                },
            },
            {
                type: SideEditOptions.Select,
                config: {
                    key: "img-location",
                    label: "Afbeelding locatie",
                    defaultValue: "object-center",
                    open: false,
                    selectOptions: [
                        {
                            value: "object-left",
                            label: "Links",
                        },
                        {
                            value: "object-right",
                            label: "Rechts",
                        },
                        {
                            value: "object-top",
                            label: "Boven",
                        },
                        {
                            value: "object-bottom",
                            label: "Beneden",
                        },
                        {
                            value: "object-center",
                            label: "Center",
                        },
                    ],
                },
            },
        ], "container-1"), ...renderElement.renderClassName("container-1", ""), children: _jsxs("div", { "editor-focuskey": "container-1", className: `relative flex h-96 w-full items-center justify-center ${renderElement.renderProp("container-1", "bg-cover")
                ?.backgroundColor || "bg-site-400"}`, children: [_jsx("div", { className: "absolute inset-0", children: _jsx("img", { "editor-focuskey": "container-1", className: classNames("h-full w-full object-cover opacity-60", imageLocation || "object-center"), src: containerBgRender["src"] || imagePlaceholder.src, alt: "container image" }) }), _jsxs(Container, { className: "z-[1] text-center", children: [_jsx(Typography, { fontType: "heading", component: "h1", "editor-key": "title-1", ...renderElement.renderClassName("title-1", "text-white text-4xl font-bold tracking-tight sm:text-center sm:text-6xl sm:leading-tight prose"), children: renderElement.renderText("title-1", titlePlaceholder.value) }), _jsx(Typography, { fontType: "heading", component: "h2", "editor-key": "title-2", ...renderElement.renderClassName("title-2", "text-white text-2xl font-bold tracking-tight sm:text-center sm:text-4xl sm:leading-tight prose"), children: renderElement.renderText("title-2", titlePlaceholder.value) })] })] }) }));
};
export default HeroHeaderBackground;
//# sourceMappingURL=HeroHeaderBackground.js.map